var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "el-dialog",
    {
      attrs: {
        "append-to-body": "",
        width: "38%",
        title: _vm.$t("companyDetail.datachangeError"),
        visible: _vm.Dataerrorcorrection,
        "destroy-on-close": "",
      },
      on: {
        "update:visible": function ($event) {
          _vm.Dataerrorcorrection = $event
        },
      },
    },
    [
      _c(
        "el-form",
        {
          ref: "formdata",
          attrs: {
            rules: _vm.rules,
            model: _vm.formdata,
            "label-width": "90px",
          },
        },
        [
          _c(
            "el-form-item",
            {
              attrs: {
                label: _vm.$t("companyDetail.replyEmail"),
                prop: "emaile",
              },
            },
            [
              _c("el-input", {
                attrs: { placeholder: _vm.$t("companyDetail.enterEmail") },
                model: {
                  value: _vm.formdata.emaile,
                  callback: function ($$v) {
                    _vm.$set(_vm.formdata, "emaile", $$v)
                  },
                  expression: "formdata.emaile",
                },
              }),
            ],
            1
          ),
          _c(
            "el-form-item",
            {
              attrs: {
                label: _vm.$t("companyDetail.contactPhone"),
                prop: "telephone",
              },
            },
            [
              _c("el-input", {
                attrs: { placeholder: _vm.$t("companyDetail.enterPhone") },
                model: {
                  value: _vm.formdata.telephone,
                  callback: function ($$v) {
                    _vm.$set(_vm.formdata, "telephone", $$v)
                  },
                  expression: "formdata.telephone",
                },
              }),
            ],
            1
          ),
          _c(
            "el-form-item",
            {
              attrs: {
                label: _vm.$t("companyDetail.questionDse"),
                prop: "desc",
              },
            },
            [
              _c("el-input", {
                attrs: {
                  rows: 6,
                  type: "textarea",
                  placeholder: _vm.$t("companyDetail.pageDes"),
                },
                model: {
                  value: _vm.formdata.desc,
                  callback: function ($$v) {
                    _vm.$set(_vm.formdata, "desc", $$v)
                  },
                  expression: "formdata.desc",
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "span",
        {
          staticClass: "dialog-footer",
          attrs: { slot: "footer" },
          slot: "footer",
        },
        [
          _c(
            "el-button",
            {
              staticClass: "sub-confirm-btn",
              attrs: { size: "mini" },
              on: {
                click: function ($event) {
                  _vm.Dataerrorcorrection = false
                },
              },
            },
            [_vm._v(_vm._s(_vm.$t("cancel")))]
          ),
          _c(
            "el-button",
            {
              staticClass: "confirm-btn",
              attrs: { size: "mini" },
              on: {
                click: function ($event) {
                  return _vm.confirmMtji("formdata")
                },
              },
            },
            [_vm._v(_vm._s(_vm.$t("submit")))]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }